import firebase from 'firebase';
import moment from 'moment';
import { AdminCoursesModalForm, FirebaseCourse } from '../types/types';
import { uploadImage } from './uploadImage';
import { uuid } from './uuid';

export const createCourse = async (course: AdminCoursesModalForm) => {
  const file = course.image && course.image[0];
  const uid = uuid();
  const ref = firebase.firestore().collection('courses').doc(uid);
  const imageUrl = await uploadImage(file, uid);

  const data: FirebaseCourse = {
    start: moment(course.startDate)
      .set('hour', +course.startTime.split(':')[0])
      .set('minute', +course.startTime.split(':')[1])
      .toJSON(),
    title: course.title,
    description: course.description,
    images: {
      cover: imageUrl ? imageUrl.fullPath : '',
      coverThumb: imageUrl ? imageUrl.x700 : '',
    },
    duration: +course.duration,
    trainer: {
      ids: [course.trainerId],
    },
    isOnline: course.isOnline,
    recurrence: {
      isRecurring: course.isRecurring,
      daysOfWeek: course.daysOfWeek || new Array(7).fill(false),
      weekInterval: 1,
    },
    courseCategoryId: course.courseCategoryId,
    canRegister: course.canRegister,
    maxParticipants: course.canRegister ? course.maxParticipants : 0,
    roomName: course.roomName,
    created:
      firebase.firestore.FieldValue.serverTimestamp() as firebase.firestore.Timestamp,
    lastModified:
      firebase.firestore.FieldValue.serverTimestamp() as firebase.firestore.Timestamp,
  };

  return ref.set(data);
};
